import { Button } from "@mui/material";
import { ReactComponent as Pet } from "assets/img/card/pet.svg";
import TagManager from 'react-gtm-module';

export default function Mascota() {
  const tag = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'USA_Landing',
        eventCategory: 'USA_Landing',
        eventAction: 'select_seguro',
        eventLabel: 'mascotaSegura'
      },
    });
  };
  return (
    <div className="insuranceCard">
      <div className="insuranceObjects">
        <div className="">
          <div className="flex justify-center items-center">
            <Pet></Pet>
          </div>
          <div className="flex flex-col justify-center items-center pt-4">
            <div className="paraphsCards">Mascota</div>
            <div className="paraphsCards">Segura</div>
          </div>
        </div>
        <div className="referenceInsurance py-6">
          El mejor seguro para cuidar a tu perro o gato como ellos te cuidan a
          ti.
        </div>
        <Button
          style={{
            backgroundColor: "#039ecc",
            width: "212px",
            height: "48px",
            borderRadius: "8px",
            fontWeight: 600,
            fontSize: "16px",
            textAlign: "center",
            color: "#ffffff",
          }}
          onClick={tag}
          href="https://mascotasegura.inter.mx/seguro-mascota/landing"
          target="_blank"
        >
          LO QUIERO
        </Button>
        <p className="lastParaph">Desde $5 USD al mes</p>
      </div>
    </div>
  );
}
